export default {
    countries: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/country/state.js